import { onDarkBase } from "@biom3/design-tokens";
import type { ThemeOptions } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import getComponentsOverrides from "./overrides";
import { typography } from "./typography";

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "dark",
    text: {
      primary: onDarkBase.color.brand[1],
      secondary: onDarkBase.color.brand[4],
    },
    background: {
      paper: onDarkBase.color.neutral[500],
    },
    success: {
      main: onDarkBase.color.status.success.bright,
    },
  },
  typography,
};

const theme = createTheme(themeOptions);

theme.components = getComponentsOverrides(theme);

export default theme;
